require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/utils/push-alert.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/utils/push-alert.legacy.js
// module id = 652
// module chunks = 31